import { render } from "./club-detail.template.html?vue&type=template&id=18ddba19&scoped=true"
import script from "./ClubDetail.vue?vue&type=script&lang=ts"
export * from "./ClubDetail.vue?vue&type=script&lang=ts"

import "./ClubDetail.vue?vue&type=style&index=0&id=18ddba19&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18ddba19"

export default script